import { metrics } from '@atlassian/browser-metrics';

export const issuesAndDeploymentsFetched = metrics.custom({
	key: 'software.deployments.issues-and-deployments',
	slo: { threshold: 7000 },
});

export const issuesFetched = metrics.custom({
	key: 'software.deployments.issues',
	slo: { threshold: 6000 },
});

export const issuesAGSFetched = metrics.custom({
	key: 'software.deployments.issues-ags',
	slo: { threshold: 6000 },
});

export const deploymentsFetched = metrics.custom({
	key: 'software.deployments.deployments',
	slo: { threshold: 6000 },
});

export const deploymentsAGSFetched = metrics.custom({
	key: 'software.deployments.deployments-ags',
	slo: { threshold: 6000 },
});

export const deploymentPageFetched = metrics.custom({
	key: 'software.deployments.deployment-page',
	slo: { threshold: 6000 },
});
